import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Frown } from "lucide-react";

export default function NotFoundPage() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen flex flex-col items-center justify-center text-center px-6 bg-slate-50" data-testid="not-found-page">
      <Frown className="h-12 w-12 text-slate-400" />
      <h1 className="mt-4 font-display text-3xl font-bold">Halaman Tidak Ditemukan</h1>
      <p className="text-slate-500 mt-2 max-w-md">Halaman yang Anda cari tidak tersedia atau telah dipindahkan.</p>
      <Button onClick={() => navigate("/dasbor")} className="mt-6 bg-slate-900 hover:bg-slate-800 text-white">Kembali ke Dasbor</Button>
    </div>
  );
}
